import { render } from "./FreeTalk.vue?vue&type=template&id=56d5dcf4&scoped=true"
const script = {}

import "./FreeTalk.vue?vue&type=style&index=0&id=56d5dcf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d5dcf4"]])

export default __exports__